'use strict';

const processInclude = require('base/util');

import detail from './product/detail';
import search from './search/search';

$(document).ready(function () {
    processInclude(search.shopTheLookHandler);
    // logic used for highlight-modules
    processInclude(detail.addToCart);
    processInclude(detail.selectPdpSizeAttribute);
});
